(function(){
'use strict';
function init(root){

  if(!root || root.dataset.thSelectorReady==='1') return;
  root.dataset.thSelectorReady='1';
  var state={application:null,priority:null,interface:null};
  var buttons=[].slice.call(root.querySelectorAll('.thsel-option'));
  var cards=[].slice.call(root.querySelectorAll('.thsel-result-card'));
  var empty=root.querySelector('[data-empty-text]');
  var warningBox=root.querySelector('[data-warning-box]');
  var warningTitle=root.querySelector('[data-warning-title]');
  var warningText=root.querySelector('[data-warning-text]');
  var progress={application:root.querySelector('[data-progress="application"]'),priority:root.querySelector('[data-progress="priority"]'),interface:root.querySelector('[data-progress="interface"]')};
  function warn(title,text){
    if(warningBox){warningBox.style.display='block';}
    if(warningTitle){warningTitle.textContent=title||'Hinweis zur Auswahl';}
    if(warningText){warningText.textContent=text||'';}
  }
  function clearWarning(){
    if(warningBox){warningBox.style.display='none';}
    if(warningTitle){warningTitle.textContent='Hinweis zur Auswahl';}
    if(warningText){warningText.textContent='';}
  }
  function show(list,message){
    var shown=0;
    cards.forEach(function(card){card.classList.remove('active');card.style.display='none'});
    list.forEach(function(key){var card=root.querySelector('[data-rec="'+key+'"]');if(card){card.style.display='flex';card.classList.add('active');shown+=1}});
    if(empty){empty.style.display=shown>0?'none':'block';empty.textContent=shown>0?'':(message||'Für diese Auswahl ist derzeit kein passendes Produkt verfügbar.')}
  }
  function clearCards(message){
    clearWarning();
    cards.forEach(function(card){card.classList.remove('active');card.style.display='none'});
    if(empty){empty.style.display='block';empty.textContent=message||'Wählen Sie Anwendung, Ziel und Materialweg, um passende Produkte anzuzeigen.'}
  }
  function updateProgress(){
    progress.application.textContent=state.applicationLabel||'Anwendung nicht gewählt';
    progress.priority.textContent=state.priorityLabel||'Ziel nicht gewählt';
    progress.interface.textContent=state.interfaceLabel||'Materialweg nicht gewählt';
  }
  function decide(){
    updateProgress();
    if(!state.application&&!state.priority&&!state.interface){clearCards();return}
    if(!state.application||!state.priority||!state.interface){clearCards('Treffen Sie alle 3 Auswahlen, um passende Produkte anzuzeigen.');return}
    var a=state.application,p=state.priority,i=state.interface;
    clearWarning();

    if((a==='cpu'||a==='workstation')&&i==='pad'){
      warn('Pads are not used on the CPU contact surface','Thermal pads are for physical gaps such as VRAM, SSDs, memory and power components. For CPU direct contact, use Paste, PCM or Profi Flüssigmetall. We are showing the correct CPU route instead.');
      show([p==='max'?'metalliq_perf_bundle':p==='performance'?'quantum':'ultra','quantum','ultra']);
      return;
    }
    if(a==='cpu'&&p==='performance'&&i==='pad'){
      warn('Use paste for CPU performance','For CPU performance cooling, paste or PCM is the correct route. Pads do not belong between CPU and cooler unless a device has a defined factory gap, which is not the normal CPU route.');
      show(['quantum','ultra']);
      return;
    }
    if(a==='laptop'&&i==='liquid'){
      warn('Liquid metal is an expert laptop route','Most laptop refreshes should start with paste and pads. Liquid metal is electrically conductive and should only be used by experienced users on compatible surfaces.');
      show(['laptop','ultra','pad05']);
      return;
    }
    if(a==='console'&&i==='paste'){
      warn('Console service usually needs a kit route','For PS5 and console service, GAMMA/PTM or a dedicated kit is often the cleaner route than a paste-only choice.');
      show(['gamma_ps5_bundle','gamma']);
      return;
    }
    if((a==='ssd'||a==='console')&&i==='liquid'){
      warn('Liquid metal does not fit this route','Liquid metal is conductive and only for compatible direct-contact surfaces. It is not used for SSD gaps or general console gap filling.');
      show(['gamma_ps5_bundle','pad']);
      return;
    }

    if(i==='bundle'){
      if(a==='laptop'){show(['laptop']);return}
      if(a==='gpu'){show(['gpu','gamma_gpu_bundle']);return}
      if(a==='console'){show(['gamma_ps5_bundle','gamma_gpu_bundle']);return}
      if(a==='gaming'){show(['gaming_bundle']);return}
      if(a==='cpu'){show(['metalliq_perf_bundle','graphenex_perf_bundle']);return}
      if(a==='workstation'){show(['graphenex_lm','graphenex_perf_bundle']);return}
    }
    if(i==='liquid'){
      if(a==='cpu'||a==='gpu'||a==='gaming'||a==='workstation'){show(['metalliq','metalliq_perf_bundle','lm_accessory_bundle']);return}
      show(['lm_accessory_bundle']);return
    }
    if(i==='graphene'){
      if(a==='workstation'||a==='gaming'||a==='gpu'||a==='cpu'){show(['graphenex','graphenex_perf_bundle','graphenex_lm']);return}
      show(['graphenex']);return
    }
    if(i==='pcm'){
      if(a==='console'){show(['gamma_ps5_bundle','gamma']);return}
      if(a==='gpu'){show(['gamma_gpu_bundle','gamma_service','gamma']);return}
      show(['gamma']);return
    }
    if(i==='pad'||p==='gap'){
      if(a==='laptop'){show(['laptop','pad','pad05']);return}
      if(a==='gpu'){show(['gpu','pad','pad05']);return}
      if(a==='console'){show(['gamma_ps5_bundle','pad']);return}
      show(['pad','pad05']);return
    }
    if(i==='paste'){
      if(a==='laptop'){show(['laptop','ultra']);return}
      if(a==='gpu'){show(['gpu','quantum','ultra']);return}
      if(a==='gaming'){show(['gaming_bundle','quantum','ultra']);return}
      if(a==='workstation'){show(['quantum','gamma']);return}
      if(a==='cpu'){show([p==='easy'?'ultra':p==='performance'?'quantum':p==='max'?'metalliq':'gamma','quantum','ultra']);return}
      show(['ultra','quantum']);return
    }
    if(i==='auto'){
      if(a==='laptop'){show(['laptop','ultra','pad']);return}
      if(a==='gpu'){show([p==='gap'?'gpu':p==='max'?'metalliq_perf_bundle':'gpu',p==='max'?'graphenex_lm':'quantum']);return}
      if(a==='console'){show(['gamma_ps5_bundle','gamma']);return}
      if(a==='gaming'){show([p==='max'?'gaming_bundle':p==='performance'?'gaming_bundle':'quantum','ultra']);return}
      if(a==='workstation'){show([p==='max'?'graphenex_lm':'quantum',p==='performance'?'graphenex_perf_bundle':'gamma']);return}
      if(a==='cpu'){show([p==='easy'?'ultra':p==='performance'?'quantum':p==='max'?'metalliq_perf_bundle':'gamma','quantum']);return}
    }
    show(['ultra','gamma']);
  }
  buttons.forEach(function(btn){
    btn.addEventListener('click',function(){
      var group=btn.closest('[data-step]');if(!group)return;
      var step=group.getAttribute('data-step');
      state[step]=btn.getAttribute('data-value');
      state[step+'Label']=btn.getAttribute('data-label')||btn.textContent.trim();
      [].slice.call(group.querySelectorAll('.thsel-option')).forEach(function(b){b.classList.remove('active')});
      btn.classList.add('active');
      decide();
    });
  });
  var autoBtn=root.querySelector('[data-route-auto]');
  var pasteBtn=root.querySelector('[data-route-paste]');
  function setRoute(value,label){
    var group=root.querySelector('[data-step="interface"]');
    if(!group)return;
    var btn=group.querySelector('[data-value="'+value+'"]');
    if(!btn)return;
    state.interface=value;
    state.interfaceLabel=label||btn.getAttribute('data-label')||btn.textContent.trim();
    [].slice.call(group.querySelectorAll('.thsel-option')).forEach(function(b){b.classList.remove('active')});
    btn.classList.add('active');
    decide();
  }
  if(autoBtn){autoBtn.addEventListener('click',function(){setRoute('auto','Beste Empfehlung')});}
  if(pasteBtn){pasteBtn.addEventListener('click',function(){setRoute('paste','Paste')});}
  var reset=root.querySelector('.thsel-reset');
  if(reset){reset.addEventListener('click',function(){state={application:null,priority:null,interface:null};buttons.forEach(function(btn){btn.classList.remove('active')});updateProgress();clearCards()})}
  updateProgress();
  clearCards();

}
function initAll(scope){
  (scope||document).querySelectorAll('[data-th-selector]').forEach(init);
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initAll(document)});}else{initAll(document);}
document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
// Delegated fallback: if Shopify swaps/re-renders the section, initialize before the first click.
document.addEventListener('click',function(e){var root=e.target.closest&&e.target.closest('[data-th-selector]');if(root&&root.dataset.thSelectorReady!=='1')init(root);},true);
})();
